import { motion } from "framer-motion"
import { useTheme } from "../theme/ThemeProvider"

export function ThemeToggle({ variant = "button" }: { variant?: "button" | "compact" }) {
  const { theme, toggleTheme } = useTheme()
  const isDemon = theme === "demon"

  if (variant === "compact") {
    return (
      <motion.button
        type="button"
        whileTap={{ scale: 0.94 }}
        whileHover={{ 
          borderColor: "var(--accent)",
          boxShadow: isDemon ? "0 0 12px rgba(255, 43, 79, 0.3)" : "0 0 12px rgba(46, 214, 181, 0.3)",
        }}
        onClick={toggleTheme}
        className="mono"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          padding: "0 14px",
          height: "36px",
          border: "1px solid rgba(255, 255, 255, 0.15)",
          background: "transparent",
          color: "var(--text)",
          cursor: "pointer",
          fontSize: "11px",
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          transition: "all 0.2s ease",
        }}
        aria-label={`Switch to ${isDemon ? "Fairy" : "Demon"} mode`}
      >
        <span style={{ fontSize: "14px" }}>{isDemon ? "👹" : "🧚"}</span>
        <span>{isDemon ? "DEMON" : "FAIRY"}</span>
      </motion.button>
    )
  }

  return (
    <motion.button
      type="button"
      whileTap={{ scale: 0.94 }}
      whileHover={{ 
        scale: 1.02,
        borderColor: "var(--accent)",
        boxShadow: isDemon ? "0 0 15px rgba(255, 43, 79, 0.3)" : "0 0 15px rgba(46, 214, 181, 0.3)",
      }}
      onClick={toggleTheme}
      className="mono"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        padding: "10px 18px",
        minHeight: "44px",
        border: "1px solid var(--rail)",
        background: isDemon ? "rgba(18,18,20,0.5)" : "rgba(244,255,251,0.92)",
        color: isDemon ? "var(--text)" : "#1f2d42",
        cursor: "pointer",
        fontSize: "12px",
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        transition: "all 0.2s ease",
      }}
      aria-pressed={!isDemon}
    >
      <span style={{ fontSize: "16px" }}>{isDemon ? "👹" : "🧚"}</span>
      <span>{isDemon ? "DEMON" : "FAIRY"}</span>
    </motion.button>
  )
}

export default ThemeToggle
